import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { USER_QUERY } from '../graphql/queries'
import { FETCH_USER_DETAILS } from '../redux/action-types'
import { cleanupFetchUserDetails } from '../redux/actions'

const useUserDetailsQuery = lazy => {
  const dispatch = useDispatch()
  const { isLoading, error, data } = useSelector(store => store.users.user)

  const refetch = useCallback(
    id =>
      apolloService.query({
        query: USER_QUERY,
        variables: { id },
        dispatch,
        action: FETCH_USER_DETAILS,
      }),
    [dispatch],
  )

  useCleanupRedux(cleanupFetchUserDetails)

  useEffect(() => {
    if (!lazy) {
      refetch()
    }
  }, [lazy, refetch])

  const queryState = { isLoading, error, data }
  return lazy ? [refetch, queryState] : queryState
}

export default useUserDetailsQuery
